import React, { useMemo } from 'react';
import Select from 'components/global/CUK/AsyncSelect/Select';
import { useTranslation } from 'react-i18next';
import { OptionMultiCount } from 'components/global/CUK/AsyncSelect/components/Option';
import GroupHeading from 'components/global/CUK/AsyncSelect/components/GroupHeading'
import { CATEGORIES_ROLES } from '../../roles-mapping'

const RolesSelect = ({ onChange, values = [] }) => {
  const { t } = useTranslation();
  const groupedOptions = useMemo(() => {
    return CATEGORIES_ROLES.map(category => ({
      label: t(`auth.admin.role.category.${category.name}`),
      options: Object.keys(category.roles).map(roleKey => ({
        label: t(`auth.admin.role.${roleKey}`),
        value: roleKey,
        id: roleKey,
        tooltip: t(`auth.admin.role.tooltip.${roleKey}`),
      }))
    }))
  }, [t])
  
  const allOptions = useMemo(() => {
    return groupedOptions.flatMap(group => group.options);
  }, [groupedOptions]);

  return (
    <Select
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      options={groupedOptions}
      mainField="label"
      placeholder={t('auth.admin.roles_placeholder')}
      onChange={(values) => onChange(values.map(({ value }) => value))}
      components={{
        Option: (props) => {
          return (
            <OptionMultiCount {...props} value={props.data} />
          );
        },
        GroupHeading,
      }}
      value={allOptions.filter(
        (option) => values.findIndex((value) => option.value === value) > -1,
      )}
    />
  );
};

export default RolesSelect;
